// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondaryButton_secondaryButton__a2p65"};